import { SupportedLangCode } from '../../config/languages';

export type FaqSchemaItem = {
    question: string;
    answer: string;
};

export const FAQ_SCHEMA_BY_LANG: Record<SupportedLangCode, FaqSchemaItem[]> = {
    sr: [
        {
            question: 'Šta je online psihoterapija?',
            answer: 'Online psihoterapija je profesionalna terapijska usluga koja se pruža putem interneta — video pozivom sa licenciranim psihoterapeutom. Omogućava vam da primate stručnu psihološku podršku iz udobnosti vašeg doma, bez potrebe za fizičkim odlaskom kod terapeuta.',
        },
        {
            question: 'Kako da zakažem online terapiju?',
            answer: 'Zakazivanje online psihoterapije na BalancePath-u je jednostavno: izaberite terapeuta koji vam odgovara, odaberite slobodan termin u kalendaru, potvrdite i izvršite uplatu. Potvrdu ćete dobiti putem email-a.',
        },
        {
            question: 'Da li su terapeuti na BalancePath-u licencirani?',
            answer: 'Na BalancePath platformi rade psihoterapeuti koji su stekli licencu, kao i terapeuti koji su u procesu licenciranja, u pravcima odobrenim od strane nacionalnih udruženja u njihovim državama. Status i kvalifikacije svakog terapeuta jasno su istaknuti na njegovom profilu.',
        },
        {
            question: 'Koliko traje jedna online psihoterapijska sesija?',
            answer: 'Standardna online psihoterapijska sesija traje 50 minuta. Dužina može varirati u zavisnosti od tipa terapije i dogovora sa vašim psihoterapeutom.',
        },
        {
            question: 'Da li je online psihoterapija efikasna?',
            answer: 'Da, online psihoterapija je klinički dokazano efikasna. Naučna istraživanja pokazuju da online terapija može biti jednako efikasna kao tradicionalna terapija licem u lice, posebno za anksioznost, depresiju i stres.',
        },
        {
            question: 'Koliko košta online psihoterapija?',
            answer: 'Cene online psihoterapije na BalancePath-u variraju u zavisnosti od terapeuta. Svaki terapeut samostalno određuje cenu svojih usluga, koja je jasno istaknuta na njihovom profilu.',
        },
        {
            question: 'Da li su online terapijske sesije poverljive?',
            answer: 'Da, sve online psihoterapijske sesije su strogo poverljive. Vlasnik platforme nema uvid u sesije niti prati komunikaciju između terapeuta i klijenta. Poštujemo etičke standarde i zakone o zaštiti podataka.',
        },
        {
            question: 'Koji tipovi online terapije se nude?',
            answer: 'Na BalancePath-u nudimo individualnu i partnersku online psihoterapiju. Naši terapeuti koriste različite pristupe: kognitivno-bihejvioralnu terapiju (CBT), psihoanalitičku terapiju, terapiju usmerenu na rešenje i druge metode.',
        },
        {
            question: 'Kako funkcioniše plaćanje za online terapiju?',
            answer: 'Plaćanje se vrši nakon zakazivanja termina, a pre početka sesije. Prihvatamo bankarski transfer iz Srbije i inostranstva. Uplatu je potrebno izvršiti u roku od 24 sata od zakazivanja.',
        },
    ],
    en: [
        {
            question: 'What is online psychotherapy?',
            answer: 'Online psychotherapy is a professional therapeutic service delivered over the internet via video call with a licensed psychotherapist. It allows you to receive expert psychological support from the comfort of your home without visiting a therapist in person.',
        },
        {
            question: 'How do I book online therapy?',
            answer: 'Booking online psychotherapy on BalancePath is simple: choose a therapist who fits your needs, select an available time slot, confirm your appointment, and complete payment. You will receive confirmation by email.',
        },
        {
            question: 'Are BalancePath therapists licensed?',
            answer: "The BalancePath platform features psychotherapists who hold a license as well as therapists who are currently in the process of obtaining one, in modalities approved by national associations in their countries. Each therapist's status and qualifications are clearly displayed on their profile.",
        },
        {
            question: 'How long does an online psychotherapy session last?',
            answer: 'A standard online psychotherapy session lasts 50 minutes. Duration may vary depending on the type of therapy and agreement with your psychotherapist.',
        },
        {
            question: 'Is online psychotherapy effective?',
            answer: 'Yes, online psychotherapy is clinically proven to be effective. Research shows that online therapy can be as effective as traditional face-to-face therapy, especially for anxiety, depression, and stress.',
        },
        {
            question: 'How much does online psychotherapy cost?',
            answer: 'Prices for online psychotherapy on BalancePath vary by therapist. Each therapist sets their own fees, which are clearly displayed on their profile.',
        },
        {
            question: 'Are online therapy sessions confidential?',
            answer: 'Yes, all online psychotherapy sessions are strictly confidential. The platform owner has no access to sessions and does not monitor communication between therapist and client. We comply with ethical standards and data protection laws.',
        },
        {
            question: 'What types of online therapy are offered?',
            answer: 'BalancePath offers individual and couples online psychotherapy. Our therapists use various approaches including cognitive behavioral therapy (CBT), psychoanalytic therapy, solution-focused therapy, and other methods.',
        },
        {
            question: 'How does payment for online therapy work?',
            answer: 'Payment is made after booking an appointment and before the session begins. We accept bank transfers from Serbia and abroad. Payment must be completed within 24 hours of booking.',
        },
    ],
    de: [
        {
            question: 'Was ist Online-Psychotherapie?',
            answer: 'Online-Psychotherapie ist eine professionelle therapeutische Leistung über das Internet per Videogespräch mit einem lizenzierten Psychotherapeuten. Sie ermöglicht Ihnen, fachkundige psychologische Unterstützung bequem von zu Hause zu erhalten, ohne persönlich zum Therapeuten zu gehen.',
        },
        {
            question: 'Wie buche ich eine Online-Therapie?',
            answer: 'Die Buchung einer Online-Psychotherapie auf BalancePath ist einfach: Wählen Sie einen passenden Therapeuten, wählen Sie einen freien Termin, bestätigen Sie die Buchung und führen Sie die Zahlung durch. Sie erhalten eine Bestätigung per E-Mail.',
        },
        {
            question: 'Sind die Therapeuten auf BalancePath lizenziert?',
            answer: 'Auf der BalancePath-Plattform arbeiten Psychotherapeuten mit abgeschlossener Lizenz sowie Therapeuten, die sich derzeit im Lizenzierungsprozess befinden — in Richtungen, die von den nationalen Verbänden ihrer Länder anerkannt sind. Status und Qualifikationen jedes Therapeuten sind klar auf dem Profil angegeben.',
        },
        {
            question: 'Wie lange dauert eine Online-Psychotherapiesitzung?',
            answer: 'Eine standardmäßige Online-Psychotherapiesitzung dauert 50 Minuten. Die Dauer kann je nach Therapieform und Vereinbarung mit Ihrem Psychotherapeuten variieren.',
        },
        {
            question: 'Ist Online-Psychotherapie wirksam?',
            answer: 'Ja, Online-Psychotherapie ist klinisch nachgewiesen wirksam. Studien zeigen, dass Online-Therapie genauso wirksam sein kann wie traditionelle Face-to-Face-Therapie, insbesondere bei Angst, Depression und Stress.',
        },
        {
            question: 'Was kostet Online-Psychotherapie?',
            answer: 'Die Preise für Online-Psychotherapie auf BalancePath variieren je nach Therapeut. Jeder Therapeut legt seine eigenen Preise fest, die klar auf dem Profil angegeben sind.',
        },
        {
            question: 'Sind Online-Therapiesitzungen vertraulich?',
            answer: 'Ja, alle Online-Psychotherapiesitzungen sind streng vertraulich. Der Plattformbetreiber hat keinen Einblick in Sitzungen und überwacht nicht die Kommunikation zwischen Therapeut und Klient. Wir halten ethische Standards und Datenschutzgesetze ein.',
        },
        {
            question: 'Welche Arten von Online-Therapie werden angeboten?',
            answer: 'BalancePath bietet individuelle und Paar-Online-Psychotherapie an. Unsere Therapeuten verwenden verschiedene Ansätze, darunter kognitive Verhaltenstherapie (CBT), psychoanalytische Therapie, lösungsorientierte Therapie und andere Methoden.',
        },
        {
            question: 'Wie funktioniert die Bezahlung für Online-Therapie?',
            answer: 'Die Zahlung erfolgt nach der Terminbuchung und vor Beginn der Sitzung. Wir akzeptieren Banküberweisungen aus Serbien und dem Ausland. Die Zahlung muss innerhalb von 24 Stunden nach der Buchung erfolgen.',
        },
    ],
    fr: [
        {
            question: "Qu'est-ce que la psychothérapie en ligne ?",
            answer: "La psychothérapie en ligne est un service thérapeutique professionnel dispensé via Internet par appel vidéo avec un psychothérapeute agréé. Elle vous permet de recevoir un soutien psychologique expert depuis chez vous, sans vous déplacer chez un thérapeute.",
        },
        {
            question: 'Comment réserver une thérapie en ligne ?',
            answer: "Réserver une psychothérapie en ligne sur BalancePath est simple : choisissez un thérapeute adapté, sélectionnez un créneau disponible, confirmez le rendez-vous et effectuez le paiement. Vous recevrez une confirmation par e-mail.",
        },
        {
            question: 'Les thérapeutes sur BalancePath sont-ils agréés ?',
            answer: "Sur la plateforme BalancePath travaillent des psychothérapeutes agréés ainsi que des thérapeutes en cours d'obtention de leur licence, dans des approches reconnues par les associations nationales de leur pays. Le statut et les qualifications de chaque thérapeute sont clairement indiqués sur son profil.",
        },
        {
            question: 'Combien de temps dure une séance de psychothérapie en ligne ?',
            answer: "Une séance standard de psychothérapie en ligne dure 50 minutes. La durée peut varier selon le type de thérapie et l'accord avec votre psychothérapeute.",
        },
        {
            question: 'La psychothérapie en ligne est-elle efficace ?',
            answer: "Oui, la psychothérapie en ligne est cliniquement prouvée efficace. Les recherches montrent qu'elle peut être aussi efficace que la thérapie traditionnelle en face à face, notamment pour l'anxiété, la dépression et le stress.",
        },
        {
            question: 'Combien coûte la psychothérapie en ligne ?',
            answer: 'Les tarifs de la psychothérapie en ligne sur BalancePath varient selon le thérapeute. Chaque thérapeute fixe ses propres prix, clairement affichés sur son profil.',
        },
        {
            question: 'Les séances de thérapie en ligne sont-elles confidentielles ?',
            answer: "Oui, toutes les séances de psychothérapie en ligne sont strictement confidentielles. Le propriétaire de la plateforme n'a pas accès aux séances et ne surveille pas la communication entre le thérapeute et le client. Nous respectons les normes éthiques et les lois sur la protection des données.",
        },
        {
            question: 'Quels types de thérapie en ligne sont proposés ?',
            answer: 'BalancePath propose une psychothérapie en ligne individuelle et de couple. Nos thérapeutes utilisent diverses approches : thérapie cognitivo-comportementale (TCC), thérapie psychanalytique, thérapie orientée solution et autres méthodes.',
        },
        {
            question: 'Comment fonctionne le paiement pour la thérapie en ligne ?',
            answer: 'Le paiement est effectué après la réservation du rendez-vous et avant le début de la séance. Nous acceptons les virements bancaires depuis la Serbie et l\'étranger. Le paiement doit être effectué dans les 24 heures suivant la réservation.',
        },
    ],
    ru: [
        {
            question: 'Что такое онлайн-психотерапия?',
            answer: 'Онлайн-психотерапия — это профессиональная терапевтическая услуга, предоставляемая через интернет по видеосвязи с лицензированным психотерапевтом. Она позволяет получать квалифицированную психологическую поддержку из дома, без личного визита к терапевту.',
        },
        {
            question: 'Как записаться на онлайн-терапию?',
            answer: 'Запись на онлайн-психотерапию на BalancePath проста: выберите подходящего терапевта, выберите свободное время, подтвердите запись и оплатите. Подтверждение вы получите по электронной почте.',
        },
        {
            question: 'Лицензированы ли терапевты на BalancePath?',
            answer: 'На платформе BalancePath работают как лицензированные психотерапевты, так и терапевты, находящиеся в процессе получения лицензии — по направлениям, одобренным национальными ассоциациями их стран. Статус и квалификация каждого терапевта чётко указаны в его профиле.',
        },
        {
            question: 'Сколько длится одна сессия онлайн-психотерапии?',
            answer: 'Стандартная сессия онлайн-психотерапии длится 50 минут. Продолжительность может варьироваться в зависимости от типа терапии и договорённости с вашим психотерапевтом.',
        },
        {
            question: 'Эффективна ли онлайн-психотерапия?',
            answer: 'Да, онлайн-психотерапия клинически доказала свою эффективность. Исследования показывают, что она может быть столь же эффективна, как традиционная очная терапия, особенно при тревоге, депрессии и стрессе.',
        },
        {
            question: 'Сколько стоит онлайн-психотерапия?',
            answer: 'Стоимость онлайн-психотерапии на BalancePath зависит от терапевта. Каждый терапевт сам устанавливает цены, которые чётко указаны в его профиле.',
        },
        {
            question: 'Конфиденциальны ли онлайн-сессии?',
            answer: 'Да, все сессии онлайн-психотерапии строго конфиденциальны. Владелец платформы не имеет доступа к сессиям и не отслеживает общение между терапевтом и клиентом. Мы соблюдаем этические стандарты и законы о защите данных.',
        },
        {
            question: 'Какие виды онлайн-терапии предлагаются?',
            answer: 'BalancePath предлагает индивидуальную и парную онлайн-психотерапию. Наши терапевты используют различные подходы: когнитивно-поведенческую терапию (КПТ), психоаналитическую терапию, краткосрочную терапию, ориентированную на решение, и другие методы.',
        },
        {
            question: 'Как работает оплата онлайн-терапии?',
            answer: 'Оплата производится после записи на приём и до начала сессии. Мы принимаем банковские переводы из Сербии и из-за рубежа. Оплату необходимо произвести в течение 24 часов после записи.',
        },
    ],
};
